<div>
  <h6 class="odx-title-6" i18n="@@global.measurementLine">Bemaßungen</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addMeasurementLine()"
      [odxTooltip]="tooltipTextAddMeasurement"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragMeasurementLine()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.measurementLinesVisible"
      (toggleEvent)="floorplanState.measurementLinesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.measurementLinesItemTextVisible"
      (toggleEvent)="updateMeasurementLinesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.measurementLinesLocked"
      (toggleEvent)="floorplanState.measurementLinesLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
